import { JogRangeControl } from '../components/JogRangeControl';
import type { KeyframeTiming } from './keyframe-timing';

export function KeyframeTimingControls({ seconds, duration, timing, start, effectiveDuration, disabled, onMove, onTiming, onDelete, onDeselect }: {
  seconds: number; duration: number; timing: KeyframeTiming; start: number; effectiveDuration: number; disabled?: boolean;
  onMove: (seconds: number) => void; onTiming: (change: Partial<KeyframeTiming>) => void; onDelete: () => void; onDeselect: () => void;
}) {
  return <fieldset className="keyframe-timing-controls" disabled={disabled}>
    <JogRangeControl label="Key time" inputLabel="Keyframe time in seconds" value={Number(seconds.toFixed(3))} min={0} max={duration}
      step={duration / (duration * 30 - 1)} unit="s" onChange={onMove} />
    <label className="studio-select-row">Incoming<select aria-label="Keyframe transition" value={timing.transition}
      onChange={event => onTiming({ transition: event.target.value as KeyframeTiming['transition'] })}>
      <option value="transition">Transition</option><option value="cut">Cut</option>
    </select></label>
    {timing.transition !== 'cut' && <>
      <label className="studio-check"><input type="checkbox" checked={timing.durationSeconds === 'interval'}
        onChange={event => onTiming({ durationSeconds: event.target.checked ? 'interval' : 2 })} />Use entire incoming interval</label>
      {timing.durationSeconds !== 'interval' && <JogRangeControl label="Duration" value={timing.durationSeconds} min={.1} max={30} step={.1} unit="s"
        onChange={durationSeconds => onTiming({ durationSeconds })} />}
      <label className="studio-select-row">Easing<select aria-label="Keyframe easing" value={timing.easing}
        onChange={event => onTiming({ easing: event.target.value as KeyframeTiming['easing'] })}>
        <option value="smooth">Smooth</option><option value="linear">Linear</option>
      </select></label>
      <p>Starts {start.toFixed(2)}s · arrives {seconds.toFixed(2)}s · {effectiveDuration.toFixed(2)}s effective</p>
    </>}
    <div className="key-actions"><button type="button" onClick={onDelete}>Delete key</button><button type="button" onClick={onDeselect}>Deselect</button></div>
  </fieldset>;
}
